import { css } from '@linaria/core'
import { style } from '#styles/index'

export const partPeriodInputClass = css`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 4px 8px;
  border: 1px solid ${style.theme.borderInput};
  min-height: 30px;
  font-size: inherit;

  color: ${style.theme.textDefault};
  background-color: ${style.theme.backgroundSurfacePrimary};
  outline: 2px solid transparent;
  transition: 0.25s ease border-color, 0.25s ease outline-color, 0.25s ease color;
  outline-offset: -2px;

  &._disabled {
    pointer-events: none;
    background-color: ${style.theme.backgroundSurfaceTertiary};
    border-color: ${style.theme.textSoft};
    
    > ._icon {
      background-color: ${style.theme.textSoft};
    }
  }
  
  &:hover {
    border-color: ${style.theme.borderHover}
  }

  &:focus {
    outline-color: ${style.theme.borderOutline};
    border-color: ${style.theme.borderOutline};
  }
  
  > ._period {
    font-variant: tabular-nums;
  }
  
  > ._icon {
    background-color: ${style.theme.textSoft};
  }
`
